var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Type, Transform } from 'class-transformer';
import { IsInt, IsNumber, IsIn, IsArray, IsString, IsDateString, IsUUID, IsNotEmpty, ValidateNested, IsOptional, IsBoolean, } from 'class-validator';
import { injectable } from 'inversify';
import { HttpService } from '@vk-hr-tek/core/http';
import { FiltersResponse, } from '@vk-hr-tek/core/filter';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';
import { QueryService } from '@vk-hr-tek/core/query';
export class GetCompanyPositionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyPositionsParams.prototype, "company_id", void 0);
export class GetTimezoneEmployeesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetTimezoneEmployeesParams.prototype, "company_id", void 0);
export class GetCompanyTimezonesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyTimezonesParams.prototype, "company_id", void 0);
export class GetTimezoneExceptionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetTimezoneExceptionsParams.prototype, "company_id", void 0);
export class GetAvailableCompanyTimezoneFiltersParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetAvailableCompanyTimezoneFiltersParams.prototype, "company_id", void 0);
export class UpdateCompanyCeoParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyCeoParams.prototype, "company_id", void 0);
export class GetCompanyCeoParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyCeoParams.prototype, "company_id", void 0);
export class SetCompanySmevValidationEsiaParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SetCompanySmevValidationEsiaParams.prototype, "company_id", void 0);
export class GetCompanySmevValidationEsiaParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanySmevValidationEsiaParams.prototype, "company_id", void 0);
export class SetCompanySmevValidationErrorsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SetCompanySmevValidationErrorsParams.prototype, "company_id", void 0);
export class GetCompanySmevValidationErrorsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanySmevValidationErrorsParams.prototype, "company_id", void 0);
export class UpdateEventTypeParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateEventTypeParams.prototype, "event_type_id", void 0);
export class CompanyEventTypesCollectionParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEventTypesCollectionParams.prototype, "event_type_id", void 0);
export class CompanyEventTypesCollectionOptionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEventTypesCollectionOptionsParams.prototype, "event_type_id", void 0);
export class UpdateCompanyProfilesSettingsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyProfilesSettingsParams.prototype, "company_id", void 0);
export class GetCompanyProfilesSettingsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyProfilesSettingsParams.prototype, "company_id", void 0);
export class GetNodeOptionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetNodeOptionsParams.prototype, "event_type_id", void 0);
export class UpdateNodesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateNodesParams.prototype, "event_type_id", void 0);
export class GetNewWorkflowParticipantOptionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetNewWorkflowParticipantOptionsParams.prototype, "event_type_id", void 0);
export class DeleteWorkflowParticipantParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteWorkflowParticipantParams.prototype, "event_type_id", void 0);
export class AddWorkflowParticipantParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddWorkflowParticipantParams.prototype, "event_type_id", void 0);
export class DeleteValidatorParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteValidatorParams.prototype, "event_type_id", void 0);
export class UpdateValidatorParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateValidatorParams.prototype, "event_type_id", void 0);
export class GetEventTypeWorkflowParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventTypeWorkflowParams.prototype, "event_type_id", void 0);
export class GetUnitStaffParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitStaffParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitStaffParams.prototype, "unit_id", void 0);
export class DeleteUnitParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteUnitParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteUnitParams.prototype, "unit_id", void 0);
export class UpdateUnitParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateUnitParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateUnitParams.prototype, "unit_id", void 0);
export class GetUnitParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitParams.prototype, "unit_id", void 0);
export class CreateUnitParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateUnitParams.prototype, "company_id", void 0);
export class GetUnitChildrenParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitChildrenParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitChildrenParams.prototype, "unit_id", void 0);
export class GetUnitChildrenForBatchParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitChildrenForBatchParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitChildrenForBatchParams.prototype, "unit_id", void 0);
export class GetUnitsTreeParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitsTreeParams.prototype, "company_id", void 0);
export class GetUnitsTreeForBatchParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitsTreeForBatchParams.prototype, "company_id", void 0);
export class GetUnitTypesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetUnitTypesParams.prototype, "company_id", void 0);
export class GetCompanySubstituteEmployeesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanySubstituteEmployeesParams.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanySubstituteEmployeesParams.prototype, "employee_id", void 0);
export class GetCompanyEmployeesWithoutRoleModelParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyEmployeesWithoutRoleModelParams.prototype, "company_id", void 0);
export class GetCompanyEmployeesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyEmployeesParams.prototype, "company_id", void 0);
export class GetCompanyEventTypesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyEventTypesParams.prototype, "company_id", void 0);
export class GetCompanyGroupUsersParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyGroupUsersParams.prototype, "company_id", void 0);
export class GetCompanyLogoByIdParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyLogoByIdParams.prototype, "company_id", void 0);
export class UpdateCompanyLogoParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyLogoParams.prototype, "company_id", void 0);
export class GetCompanyEventsStatParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyEventsStatParams.prototype, "company_id", void 0);
export class CreateCompanyGroupParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateCompanyGroupParams.prototype, "company_id", void 0);
export class GetCompanyGroupsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyGroupsParams.prototype, "company_id", void 0);
export class CheckCompanyGroupCreationParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckCompanyGroupCreationParams.prototype, "company_id", void 0);
export class UpdateCompanyManagerBlocksParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyManagerBlocksParams.prototype, "company_id", void 0);
export class ToggleCompanySkipAccountSyncParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ToggleCompanySkipAccountSyncParams.prototype, "company_id", void 0);
export class UpdateCompanySettingsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanySettingsParams.prototype, "company_id", void 0);
export class GetCompaniesFromAccountParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompaniesFromAccountParams.prototype, "company_id", void 0);
export class UpdateCompanyRoleModelParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyRoleModelParams.prototype, "company_id", void 0);
export class GetCompanyRoleModelParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyRoleModelParams.prototype, "company_id", void 0);
export class UpdateCompanyParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "company_id", void 0);
export class GetCompanyParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyParams.prototype, "company_id", void 0);
export class GetTimezoneFilterOptionsQuery {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetTimezoneFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetTimezoneFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetTimezoneFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetTimezoneFilterOptionsQuery.prototype, "offset", void 0);
export class GetProfilesOptionsQuery {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetProfilesOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetProfilesOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetProfilesOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetProfilesOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetProfilesOptionsQuery.prototype, "offset", void 0);
export class GetProfilesQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetProfilesQuery.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetProfilesQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetProfilesQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetProfilesQuery.prototype, "offset", void 0);
export class GetManagerSubstituteAbsenceOptionsQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetManagerSubstituteAbsenceOptionsQuery.prototype, "employee_id", void 0);
export class GetManagerSubstitutesQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetManagerSubstitutesQuery.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetManagerSubstitutesQuery.prototype, "employee_id", void 0);
export class GetUnitStaffQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitStaffQuery.prototype, "first_employee_id", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetUnitStaffQuery.prototype, "limit", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetUnitStaffQuery.prototype, "offset", void 0);
export class GetUnitsTreeQuery {
}
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsTreeQuery.prototype, "unit_type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsTreeQuery.prototype, "unit_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetUnitsTreeQuery.prototype, "vacation_data", void 0);
export class GetUnitsTreeForBatchQuery {
}
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsTreeForBatchQuery.prototype, "unit_type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsTreeForBatchQuery.prototype, "unit_id", void 0);
export class GetSegmentsFilterOptionsQuery {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetSegmentsFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetSegmentsFilterOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetSegmentsFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetSegmentsFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetSegmentsFilterOptionsQuery.prototype, "offset", void 0);
export class GetAbsenceTypesOptionsQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetAbsenceTypesOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetAbsenceTypesOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetAbsenceTypesOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetAbsenceTypesOptionsQuery.prototype, "offset", void 0);
export class GetUnitsOptionsQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsOptionsQuery.prototype, "unit_type", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetUnitsOptionsQuery.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetUnitsOptionsQuery.prototype, "query", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetUnitsOptionsQuery.prototype, "query_include_root", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetUnitsOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetUnitsOptionsQuery.prototype, "offset", void 0);
export class GetCompanySubstituteEmployeesQuery {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanySubstituteEmployeesQuery.prototype, "query", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetCompanySubstituteEmployeesQuery.prototype, "limit", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetCompanySubstituteEmployeesQuery.prototype, "offset", void 0);
export class GetCompanyEmployeesWithoutRoleModelQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyEmployeesWithoutRoleModelQuery.prototype, "employee_id", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetCompanyEmployeesWithoutRoleModelQuery.prototype, "limit", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesWithoutRoleModelQuery.prototype, "query", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetCompanyEmployeesWithoutRoleModelQuery.prototype, "offset", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyEmployeesWithoutRoleModelQuery.prototype, "ids", void 0);
export class GetCompanyEventTypesQuery {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyEventTypesQuery.prototype, "has_manager", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEventTypesQuery.prototype, "manager_type", void 0);
export class GetCompanyLogoQuery {
}
__decorate([
    IsIn(['main', 'compact']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyLogoQuery.prototype, "version", void 0);
__decorate([
    IsIn(['strict', 'fallback']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyLogoQuery.prototype, "mode", void 0);
export class GetCompanyLogoByIdQuery {
}
__decorate([
    IsIn(['main', 'compact']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyLogoByIdQuery.prototype, "version", void 0);
__decorate([
    IsIn(['strict', 'fallback']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyLogoByIdQuery.prototype, "mode", void 0);
export class GetCompanyGroupsQuery {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyGroupsQuery.prototype, "include_all", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyGroupsQuery.prototype, "group_name", void 0);
export class FilterSelectBadge {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "description", void 0);
__decorate([
    IsIn(['blue', 'velvet', 'red']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "color", void 0);
__decorate([
    IsIn(['left', 'bottom']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "position", void 0);
export class FilterSelectOption {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelectOption.prototype, "value", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelectOption.prototype, "label", void 0);
__decorate([
    IsIn(['item']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectOption.prototype, "type", void 0);
__decorate([
    ValidateNested(),
    Type(() => FilterSelectBadge),
    IsOptional(),
    __metadata("design:type", FilterSelectBadge)
], FilterSelectOption.prototype, "badge", void 0);
export class AbsenceGroup {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceGroup.prototype, "name", void 0);
__decorate([
    IsIn([
        'vacation',
        'maternity_leave',
        'student_leave',
        'business_trip',
        'sick_leave',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceGroup.prototype, "nick", void 0);
export class EmployeeAbsence {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeAbsence.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeAbsence.prototype, "to_date", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EmployeeAbsence.prototype, "days_count", void 0);
__decorate([
    ValidateNested(),
    Type(() => AbsenceGroup),
    IsNotEmpty(),
    __metadata("design:type", AbsenceGroup)
], EmployeeAbsence.prototype, "absence_group", void 0);
export class CompanyItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyItem.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyItem.prototype, "tsp_url", void 0);
__decorate([
    IsIn(['capi', 'cades']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyItem.prototype, "crypto_pro_plugin_open_type", void 0);
__decorate([
    IsIn(['api', 'browser_plugin']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyItem.prototype, "hash_source", void 0);
export class CompanyEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "first_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "middle_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "last_name", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], CompanyEmployee.prototype, "company", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "email", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "personnel_number", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "position", void 0);
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "sign_type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "unit_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "expanded_unit_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "unit_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "unit_breadcrumbs", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "user_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeAbsence),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CompanyEmployee.prototype, "absences", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "org_structure_type", void 0);
export class TimezoneEmployee {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEmployee),
    IsNotEmpty(),
    __metadata("design:type", CompanyEmployee)
], TimezoneEmployee.prototype, "employee", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], TimezoneEmployee.prototype, "timezone_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], TimezoneEmployee.prototype, "timezone_name", void 0);
__decorate([
    IsIn(['unknown', 'waiting', 'success', 'error']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], TimezoneEmployee.prototype, "status", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], TimezoneEmployee.prototype, "description", void 0);
export class TimezoneEmployeesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => TimezoneEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], TimezoneEmployeesResponse.prototype, "employees", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], TimezoneEmployeesResponse.prototype, "total_count", void 0);
export class CompanyTimezone {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyTimezone.prototype, "name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyTimezone.prototype, "id", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], CompanyTimezone.prototype, "employee_count", void 0);
export class CompanyTimezonesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyTimezone),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompanyTimezonesResponse.prototype, "timezones", void 0);
export class TimezoneException {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEmployee),
    IsNotEmpty(),
    __metadata("design:type", CompanyEmployee)
], TimezoneException.prototype, "employee", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], TimezoneException.prototype, "timezone_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], TimezoneException.prototype, "timezone_name", void 0);
export class TimezoneExceptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => TimezoneException),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], TimezoneExceptionsResponse.prototype, "exceptions", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], TimezoneExceptionsResponse.prototype, "total_count", void 0);
export class FilterMultipleSearch {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "name", void 0);
__decorate([
    IsIn(['multiple-search']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "url", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "placeholder", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterMultipleSearch.prototype, "hidden", void 0);
export class AvailableFilters {
}
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AvailableFilters.prototype, "filters", void 0);
export class GetAccessLevelsResponse {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetAccessLevelsResponse.prototype, "items", void 0);
export class Cases {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cases.prototype, "genitive", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cases.prototype, "dative", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cases.prototype, "accusative", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cases.prototype, "creative", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Cases.prototype, "prepositional", void 0);
export class GetCompanyCeoResponse {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyCeoResponse.prototype, "first_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyCeoResponse.prototype, "last_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyCeoResponse.prototype, "middle_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyCeoResponse.prototype, "position", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], GetCompanyCeoResponse.prototype, "first_name_cases", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], GetCompanyCeoResponse.prototype, "last_name_cases", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], GetCompanyCeoResponse.prototype, "middle_name_cases", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], GetCompanyCeoResponse.prototype, "position_cases", void 0);
export class SmevValidationEsiaResponse {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], SmevValidationEsiaResponse.prototype, "ignore_smev_errors_esia", void 0);
export class CertificateError {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CertificateError.prototype, "id", void 0);
__decorate([
    IsIn(['smev', 'release']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CertificateError.prototype, "source", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CertificateError.prototype, "code", void 0);
__decorate([
    IsIn(['fatal', 'warning']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CertificateError.prototype, "level", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CertificateError.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CertificateError.prototype, "ignore", void 0);
export class SmevValidationErrorsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CertificateError),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], SmevValidationErrorsResponse.prototype, "smev_errors", void 0);
export class CollectionOption {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CollectionOption.prototype, "external_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CollectionOption.prototype, "name", void 0);
export class CompanyEventTypeItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEventTypeItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEventTypeItem.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CompanyEventTypeItem.prototype, "disabled", void 0);
export class GetCollectionOptionsResponse {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], GetCollectionOptionsResponse.prototype, "company", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyEventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyEventTypeItem)
], GetCollectionOptionsResponse.prototype, "event_type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CollectionOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCollectionOptionsResponse.prototype, "collections", void 0);
export class UnitItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitItem.prototype, "name", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitItem.prototype, "type", void 0);
export class CompanyProfilesSettings {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CompanyProfilesSettings.prototype, "enabled", void 0);
__decorate([
    IsIn(['import', 'units']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyProfilesSettings.prototype, "source", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyProfilesSettings.prototype, "unit_type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CompanyProfilesSettings.prototype, "include_separate_units", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitItem),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CompanyProfilesSettings.prototype, "units", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitItem),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CompanyProfilesSettings.prototype, "separate_units", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CompanyProfilesSettings.prototype, "vacation_schedule_profiles", void 0);
export class ProfileItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ProfileItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ProfileItem.prototype, "name", void 0);
export class CompanyProfiles {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], CompanyProfiles.prototype, "company", void 0);
__decorate([
    IsIn(['import', 'units']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyProfiles.prototype, "source", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ProfileItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompanyProfiles.prototype, "profiles", void 0);
export class GetProfilesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyProfiles),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetProfilesResponse.prototype, "profiles", void 0);
export class CompanyGroup {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyGroup.prototype, "name", void 0);
export class GetCompanyGroupListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyGroup),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCompanyGroupListResponse.prototype, "items", void 0);
export class DeadlineSettingAttribute {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeadlineSettingAttribute.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeadlineSettingAttribute.prototype, "name", void 0);
export class DeadlineSettingsOptions {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => DeadlineSettingAttribute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], DeadlineSettingsOptions.prototype, "attributes", void 0);
export class GroupItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupItem.prototype, "name", void 0);
export class GetNodeOptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => GroupItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetNodeOptionsResponse.prototype, "groups", void 0);
__decorate([
    ValidateNested(),
    Type(() => DeadlineSettingsOptions),
    IsNotEmpty(),
    __metadata("design:type", DeadlineSettingsOptions)
], GetNodeOptionsResponse.prototype, "deadline_settings", void 0);
export class GetNewWorkflowParticipantOptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => GroupItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetNewWorkflowParticipantOptionsResponse.prototype, "groups", void 0);
export class AvailableDaysCheckValidatorSettings {
}
__decorate([
    IsIn(['available_days_check']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AvailableDaysCheckValidatorSettings.prototype, "type", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AvailableDaysCheckValidatorSettings.prototype, "operation", void 0);
export class AbsenceDaysCheckValidatorSettings {
}
__decorate([
    IsIn(['absence_days_check']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceDaysCheckValidatorSettings.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceDaysCheckValidatorSettings.prototype, "days_check", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], AbsenceDaysCheckValidatorSettings.prototype, "working_days_only", void 0);
export class CheckValueValidatorSettings {
}
__decorate([
    IsIn(['check_value']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidatorSettings.prototype, "type", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidatorSettings.prototype, "operation", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidatorSettings.prototype, "value", void 0);
export class ValuesCompareValidatorSettings {
}
__decorate([
    IsIn(['values_compare']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValuesCompareValidatorSettings.prototype, "type", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValuesCompareValidatorSettings.prototype, "operation", void 0);
export class MinHiringDayValidatorSettings {
}
__decorate([
    IsIn(['min_hiring_day']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinHiringDayValidatorSettings.prototype, "type", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinHiringDayValidatorSettings.prototype, "operation", void 0);
export class DivisibleByValidatorSettings {
}
__decorate([
    IsIn(['divisible_by']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DivisibleByValidatorSettings.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], DivisibleByValidatorSettings.prototype, "days_count", void 0);
export class MaxDurationValidatorSettings {
}
__decorate([
    IsIn(['max_duration']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxDurationValidatorSettings.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MaxDurationValidatorSettings.prototype, "max_duration", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MaxDurationValidatorSettings.prototype, "working_days_only", void 0);
export class MinDurationValidatorSettings {
}
__decorate([
    IsIn(['min_duration']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinDurationValidatorSettings.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MinDurationValidatorSettings.prototype, "min_duration", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MinDurationValidatorSettings.prototype, "working_days_only", void 0);
export class MaxDateValidatorSettings {
}
__decorate([
    IsIn(['max_date']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxDateValidatorSettings.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MaxDateValidatorSettings.prototype, "days_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MaxDateValidatorSettings.prototype, "working_days_only", void 0);
export class MinDateValidatorSettings {
}
__decorate([
    IsIn(['min_date']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinDateValidatorSettings.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MinDateValidatorSettings.prototype, "days_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MinDateValidatorSettings.prototype, "working_days_only", void 0);
export class Validator {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Validator.prototype, "id", void 0);
__decorate([
    IsIn([
        'min_date',
        'max_date',
        'working_day',
        'weekend_exclusion',
        'min_duration',
        'max_duration',
        'no_overlap',
        'forbidden_periods',
        'same_month',
        'vacation_available',
        'divisible_by',
        'min_hiring_day',
        'values_compare',
        'check_value',
        'absence_days_check',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Validator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Validator.prototype, "description", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Validator.prototype, "attributes", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], Validator.prototype, "settings", void 0);
export class WorkflowTransition {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowTransition.prototype, "from_node", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowTransition.prototype, "to_node", void 0);
__decorate([
    IsIn([
        'upload',
        'accept',
        'decline',
        'decline_sign',
        'sign',
        'system',
        'generate_document_from_template',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowTransition.prototype, "action_type", void 0);
export class WorkflowManagerBlock {
}
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowManagerBlock.prototype, "manager_type", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkflowManagerBlock.prototype, "node_ids", void 0);
export class WorkflowParticipantAction {
}
__decorate([
    IsIn([
        'upload',
        'accept',
        'decline',
        'decline_sign',
        'sign',
        'system',
        'generate_document_from_template',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowParticipantAction.prototype, "action_type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], WorkflowParticipantAction.prototype, "count", void 0);
export class WorkflowParticipant {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkflowParticipant.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowParticipant.prototype, "role", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], WorkflowParticipant.prototype, "group", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], WorkflowParticipant.prototype, "employee", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], WorkflowParticipant.prototype, "levels", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], WorkflowParticipant.prototype, "number", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkflowParticipant.prototype, "editable", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkflowParticipantAction),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkflowParticipant.prototype, "actions", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkflowParticipant.prototype, "allow_delete", void 0);
export class DeadlineSetting {
}
__decorate([
    IsIn([
        'event_deadline',
        'node_active',
        'attribute',
        'created_date',
        'created_datetime',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeadlineSetting.prototype, "reference", void 0);
__decorate([
    IsIn(['minute', 'hour', 'day', 'workday']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeadlineSetting.prototype, "time_unit", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], DeadlineSetting.prototype, "term", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], DeadlineSetting.prototype, "round_days", void 0);
__decorate([
    IsIn(['to_paper', 'cancel', 'skip']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeadlineSetting.prototype, "outcome", void 0);
__decorate([
    ValidateNested(),
    Type(() => DeadlineSettingAttribute),
    IsOptional(),
    __metadata("design:type", DeadlineSettingAttribute)
], DeadlineSetting.prototype, "attribute", void 0);
export class DeadlineSettings {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => DeadlineSetting),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], DeadlineSettings.prototype, "settings", void 0);
__decorate([
    IsIn(['min_date', 'max_date']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DeadlineSettings.prototype, "mode", void 0);
export class WorkflowNodeAction {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowNodeAction.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], WorkflowNodeAction.prototype, "document_type_name", void 0);
__decorate([
    IsIn([
        'upload',
        'accept',
        'decline',
        'decline_sign',
        'sign',
        'system',
        'generate_document_from_template',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowNodeAction.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkflowNodeAction.prototype, "is_primary", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkflowNodeAction.prototype, "is_employee", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], WorkflowNodeAction.prototype, "roles", void 0);
export class WorkflowNode {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowNode.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkflowNode.prototype, "name", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkflowNodeAction),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkflowNode.prototype, "actions", void 0);
__decorate([
    ValidateNested(),
    Type(() => DeadlineSettings),
    IsOptional(),
    __metadata("design:type", DeadlineSettings)
], WorkflowNode.prototype, "deadline_settings", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkflowNode.prototype, "is_optional", void 0);
export class Workflow {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkflowNode),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Workflow.prototype, "nodes", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkflowParticipant),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Workflow.prototype, "participants", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkflowManagerBlock),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Workflow.prototype, "manager_blocks", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkflowTransition),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Workflow.prototype, "transitions", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CollectionOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Workflow.prototype, "collections", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => Validator),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Workflow.prototype, "validators", void 0);
export class GetEventTypeWorkflowResponse {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyEventTypeItem)
], GetEventTypeWorkflowResponse.prototype, "event_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => Workflow),
    IsNotEmpty(),
    __metadata("design:type", Workflow)
], GetEventTypeWorkflowResponse.prototype, "workflow", void 0);
export class ManagerSubstituteAbsenceOption {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ManagerSubstituteAbsenceOption.prototype, "type", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ManagerSubstituteAbsenceOption.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ManagerSubstituteAbsenceOption.prototype, "to_date", void 0);
export class ManagerSubstituteAbsenceOptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ManagerSubstituteAbsenceOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ManagerSubstituteAbsenceOptionsResponse.prototype, "options", void 0);
export class DateRange {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DateRange.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DateRange.prototype, "to_date", void 0);
export class ManagerSubstituteDeleteOption {
}
__decorate([
    IsIn(['ALL', 'ALL_TEMPORARY', 'ALL_PERMANENT']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ManagerSubstituteDeleteOption.prototype, "scope", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], ManagerSubstituteDeleteOption.prototype, "event_type_count", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ManagerSubstituteDeleteOption.prototype, "event_type_names", void 0);
export class ManagerSubstitute {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEmployee),
    IsNotEmpty(),
    __metadata("design:type", CompanyEmployee)
], ManagerSubstitute.prototype, "substitute", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ManagerSubstituteDeleteOption),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ManagerSubstitute.prototype, "available_options", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DateRange),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ManagerSubstitute.prototype, "dates", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ManagerSubstitute.prototype, "from_absences", void 0);
export class ManagerSubstitutesEventType {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyEventTypeItem)
], ManagerSubstitutesEventType.prototype, "event_type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ManagerSubstitute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ManagerSubstitutesEventType.prototype, "substitutes", void 0);
export class GetManagerSubstitutesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ManagerSubstitutesEventType),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetManagerSubstitutesResponse.prototype, "event_types", void 0);
export class ManagerSubstitutesEmployee {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEmployee),
    IsNotEmpty(),
    __metadata("design:type", CompanyEmployee)
], ManagerSubstitutesEmployee.prototype, "employee", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], ManagerSubstitutesEmployee.prototype, "substitutes_count", void 0);
export class GetManagerSubstitutesListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ManagerSubstitutesEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetManagerSubstitutesListResponse.prototype, "substitutes", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], GetManagerSubstitutesListResponse.prototype, "total", void 0);
export class UnitStaffPosition {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UnitStaffPosition.prototype, "position_name", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffPosition.prototype, "fte_vacancy", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], UnitStaffPosition.prototype, "is_obsolete", void 0);
export class UnitStaffEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitStaffEmployee.prototype, "id", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitStaffEmployee.prototype, "name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitStaffEmployee.prototype, "display_number", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UnitStaffEmployee.prototype, "position", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitStaffEmployee.prototype, "user_id", void 0);
__decorate([
    IsIn(['full', 'partial', 'vacant']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UnitStaffEmployee.prototype, "staff_position_state", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffEmployee.prototype, "staff_position_percent", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], UnitStaffEmployee.prototype, "company", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeAbsence),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UnitStaffEmployee.prototype, "absences", void 0);
export class UnitStaff {
}
__decorate([
    ValidateNested(),
    Type(() => UnitStaffEmployee),
    IsOptional(),
    __metadata("design:type", UnitStaffEmployee)
], UnitStaff.prototype, "employee", void 0);
__decorate([
    ValidateNested(),
    Type(() => UnitStaffPosition),
    IsOptional(),
    __metadata("design:type", UnitStaffPosition)
], UnitStaff.prototype, "staff_position", void 0);
export class GetUnitStaffResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitStaff),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetUnitStaffResponse.prototype, "staff", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], GetUnitStaffResponse.prototype, "total_count", void 0);
export class UnitStaffStats {
}
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffStats.prototype, "fte_total", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffStats.prototype, "fte_fact", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffStats.prototype, "fte_vacancy", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffStats.prototype, "ptr_total", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UnitStaffStats.prototype, "ptr_vacancy", void 0);
export class UnitManagerSetting {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyEventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyEventTypeItem)
], UnitManagerSetting.prototype, "event_type", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitManagerSetting.prototype, "approve", void 0);
export class Unit {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Unit.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Unit.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], Unit.prototype, "parent_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], Unit.prototype, "limited_access", void 0);
__decorate([
    ValidateNested(),
    Type(() => UnitStaffEmployee),
    IsOptional(),
    __metadata("design:type", UnitStaffEmployee)
], Unit.prototype, "manager", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitManagerSetting),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], Unit.prototype, "manager_settings", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyEmployee),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], Unit.prototype, "assistants", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], Unit.prototype, "is_separate", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], Unit.prototype, "has_separate_above", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Unit.prototype, "manager_setting_approve", void 0);
export class UnitPathItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitPathItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitPathItem.prototype, "name", void 0);
export class GetUnitResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitPathItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetUnitResponse.prototype, "path", void 0);
__decorate([
    ValidateNested(),
    Type(() => Unit),
    IsNotEmpty(),
    __metadata("design:type", Unit)
], GetUnitResponse.prototype, "unit", void 0);
__decorate([
    ValidateNested(),
    Type(() => UnitStaffStats),
    IsOptional(),
    __metadata("design:type", UnitStaffStats)
], GetUnitResponse.prototype, "unit_staff_stats", void 0);
__decorate([
    ValidateNested(),
    Type(() => UnitStaffStats),
    IsOptional(),
    __metadata("design:type", UnitStaffStats)
], GetUnitResponse.prototype, "combined_staff_stats", void 0);
export class CreateUnitResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateUnitResponse.prototype, "unit_id", void 0);
export class UnitNode {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitNode.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitNode.prototype, "name", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyEmployee),
    IsOptional(),
    __metadata("design:type", CompanyEmployee)
], UnitNode.prototype, "manager", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], UnitNode.prototype, "employee_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], UnitNode.prototype, "is_parent", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], UnitNode.prototype, "is_separate", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UnitNode.prototype, "has_separate_above", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UnitNode.prototype, "has_vacation_schedule", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitNode),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UnitNode.prototype, "children", void 0);
export class GetUnitChildrenResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitNode),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetUnitChildrenResponse.prototype, "units", void 0);
export class UnitsPermissions {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], UnitsPermissions.prototype, "edit_units", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], UnitsPermissions.prototype, "edit_manager_settings", void 0);
export class GetUnitsTreeResponse {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], GetUnitsTreeResponse.prototype, "total", void 0);
__decorate([
    ValidateNested(),
    Type(() => UnitNode),
    IsOptional(),
    __metadata("design:type", UnitNode)
], GetUnitsTreeResponse.prototype, "root_unit", void 0);
__decorate([
    ValidateNested(),
    Type(() => UnitsPermissions),
    IsOptional(),
    __metadata("design:type", UnitsPermissions)
], GetUnitsTreeResponse.prototype, "permissions", void 0);
export class AbsenceFilterType {
}
__decorate([
    IsIn(['vacation', 'sick_leave', 'remote_work', 'other']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceFilterType.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceFilterType.prototype, "description", void 0);
export class AbsenceFilterOption {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceFilterOption.prototype, "value", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceFilterOption.prototype, "label", void 0);
__decorate([
    ValidateNested(),
    Type(() => AbsenceFilterType),
    IsOptional(),
    __metadata("design:type", AbsenceFilterType)
], AbsenceFilterOption.prototype, "type", void 0);
export class UnitTypeItem {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitTypeItem.prototype, "name", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitTypeItem.prototype, "type", void 0);
export class GetUnitTypesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitTypeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetUnitTypesResponse.prototype, "types", void 0);
export class GetCompanyEmployeesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCompanyEmployeesResponse.prototype, "employees", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], GetCompanyEmployeesResponse.prototype, "total_count", void 0);
export class GetCompanyEmployeesSubstituteOptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCompanyEmployeesSubstituteOptionsResponse.prototype, "employees", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], GetCompanyEmployeesSubstituteOptionsResponse.prototype, "total_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], GetCompanyEmployeesSubstituteOptionsResponse.prototype, "has_account", void 0);
export class GetCompanyEventTypesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanyEventTypeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCompanyEventTypesResponse.prototype, "event_types", void 0);
export class GroupUserEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupUserEmployee.prototype, "id", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], GroupUserEmployee.prototype, "company", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupUserEmployee.prototype, "personnel_number", void 0);
export class GroupUser {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupUser.prototype, "id", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupUser.prototype, "first_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupUser.prototype, "last_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupUser.prototype, "middle_name", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => GroupUserEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GroupUser.prototype, "employees", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ProfileItem),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GroupUser.prototype, "profiles", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], GroupUser.prototype, "editable", void 0);
export class GroupUsers {
}
__decorate([
    ValidateNested(),
    Type(() => GroupItem),
    IsNotEmpty(),
    __metadata("design:type", GroupItem)
], GroupUsers.prototype, "group", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], GroupUsers.prototype, "employee_profiles_enabled", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => GroupUser),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GroupUsers.prototype, "users", void 0);
export class CompanyGroupUsers {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], CompanyGroupUsers.prototype, "company", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => GroupUsers),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompanyGroupUsers.prototype, "group_users", void 0);
export class EventStatItem {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventStatItem.prototype, "active", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventStatItem.prototype, "finished", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventStatItem.prototype, "canceled", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventStatItem.prototype, "in_paper", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventStatItem.prototype, "total", void 0);
export class TimeRange {
}
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], TimeRange.prototype, "start", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], TimeRange.prototype, "end", void 0);
export class EventTypeItemChild_button {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventTypeItemChild_button.prototype, "is_active", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => TimeRange),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventTypeItemChild_button.prototype, "active_periods", void 0);
export class EventTypeItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "name", void 0);
__decorate([
    IsIn(['item']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "custom_type", void 0);
__decorate([
    IsIn(['employee', 'candidate', 'vacation']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "category", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventTypeItem.prototype, "document_info_required", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventTypeItem.prototype, "disabled", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventTypeItem.prototype, "tags", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventTypeItemChild_button),
    IsOptional(),
    __metadata("design:type", EventTypeItemChild_button)
], EventTypeItem.prototype, "child_button", void 0);
export class EventStat {
}
__decorate([
    ValidateNested(),
    Type(() => EventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", EventTypeItem)
], EventStat.prototype, "event_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventStatItem),
    IsNotEmpty(),
    __metadata("design:type", EventStatItem)
], EventStat.prototype, "stat", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CollectionOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventStat.prototype, "collections", void 0);
export class CompanyEventsStat {
}
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], CompanyEventsStat.prototype, "company", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventStat),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompanyEventsStat.prototype, "events_stat", void 0);
export class CreateCompanyGroupResponseItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateCompanyGroupResponseItem.prototype, "company_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateCompanyGroupResponseItem.prototype, "success", void 0);
export class CreateCompanyGroupResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateCompanyGroupResponseItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateCompanyGroupResponse.prototype, "result", void 0);
export class Group {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Group.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Group.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Group.prototype, "parent_id", void 0);
export class Groups {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => Group),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Groups.prototype, "groups", void 0);
export class CheckCompanyGroupCreationResponseItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckCompanyGroupCreationResponseItem.prototype, "company_id", void 0);
__decorate([
    IsIn(['success', 'already_exists', 'no_parent_group']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckCompanyGroupCreationResponseItem.prototype, "status", void 0);
export class CheckCompanyGroupCreationResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CheckCompanyGroupCreationResponseItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CheckCompanyGroupCreationResponse.prototype, "result", void 0);
export class UpdateCompanyManagerBlocksResponse {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], UpdateCompanyManagerBlocksResponse.prototype, "updated_count", void 0);
export class EmployeeIdWithSignType {
}
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeIdWithSignType.prototype, "sign_type", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeIdWithSignType.prototype, "id", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeIdWithSignType.prototype, "first_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeIdWithSignType.prototype, "last_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeIdWithSignType.prototype, "middle_name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeIdWithSignType.prototype, "personnel_number", void 0);
export class EditableCompany {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EditableCompany.prototype, "available_sign_types", void 0);
__decorate([
    IsIn(['web', 'onecvk', 'public']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EditableCompany.prototype, "employee_sign_type_source", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], EditableCompany.prototype, "company_item", void 0);
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EditableCompany.prototype, "sign_type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeIdWithSignType),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EditableCompany.prototype, "user_with_sign_type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "import_operational_units", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "import_legal_units", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "payslips_enabled", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "role_model_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "update_managers_in_events", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EditableCompany.prototype, "employee_limit", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EditableCompany.prototype, "employee_count", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "early_employee_event_access_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "manager_starts_from_parent_unit", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "separate_units_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "employee_download_pdf_access", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "show_closest_task_widget", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "business_trips_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "search_users_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "account_role_model_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "account_role_excluded", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EditableCompany.prototype, "account_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EditableCompany.prototype, "account_name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "account_with_one_company", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "show_operational_manager", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "show_legal_manager", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "show_functional_manager", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "allow_functional", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EditableCompany.prototype, "timezone_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EditableCompany.prototype, "timezone_name", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EditableCompany.prototype, "exceptions_timezone_count", void 0);
__decorate([
    IsIn([
        'show_closest_task_widget',
        'payslips_enabled',
        'early_employee_event_access_enabled',
        'manager_starts_from_parent_unit',
        'update_managers_in_events',
        'separate_units_enabled',
        'employee_download_pdf_access',
        'import_operational_units',
        'import_legal_units',
        'business_trips_enabled',
        'search_users_enabled',
    ], { each: true }),
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EditableCompany.prototype, "skip_account_sync", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "import_timezones", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "import_timezones_available", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EditableCompany.prototype, "manager_setting_approve", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EditableCompany.prototype, "process_catalog_available", void 0);
export class OrgStructureCompanyItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], OrgStructureCompanyItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], OrgStructureCompanyItem.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], OrgStructureCompanyItem.prototype, "is_admin", void 0);
export class OrgStructureCompanyListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => OrgStructureCompanyItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], OrgStructureCompanyListResponse.prototype, "companies", void 0);
export class CompanyListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EditableCompany),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompanyListResponse.prototype, "companies", void 0);
export class RoleModelAccessControlItemKeyValue {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleModelAccessControlItemKeyValue.prototype, "name", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], RoleModelAccessControlItemKeyValue.prototype, "value", void 0);
export class RoleModelAccessControlItem {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], RoleModelAccessControlItem.prototype, "enabled", void 0);
__decorate([
    IsIn(['employees', 'managers', 'company_groups']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleModelAccessControlItem.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], RoleModelAccessControlItem.prototype, "value", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], RoleModelAccessControlItem.prototype, "group_ids", void 0);
export class RoleModelObject {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleModelObject.prototype, "name", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], RoleModelObject.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], RoleModelObject.prototype, "tooltip", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => RoleModelAccessControlItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], RoleModelObject.prototype, "access_control", void 0);
export class RoleModelDomain {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleModelDomain.prototype, "name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleModelDomain.prototype, "group_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], RoleModelDomain.prototype, "tooltip", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => RoleModelObject),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], RoleModelDomain.prototype, "objects", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => RoleModelAccessControlItemKeyValue),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], RoleModelDomain.prototype, "employees_values", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => RoleModelAccessControlItemKeyValue),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], RoleModelDomain.prototype, "managers_values", void 0);
export class GetCompanyRoleModelResponse {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], GetCompanyRoleModelResponse.prototype, "role_model_enabled", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => RoleModelDomain),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCompanyRoleModelResponse.prototype, "domains", void 0);
export class GetCompanyResponse {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyResponse.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], GetCompanyResponse.prototype, "role_model_enabled", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], GetCompanyResponse.prototype, "separate_units_enabled", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCompanyResponse.prototype, "account_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyResponse.prototype, "account_with_one_company", void 0);
export class GetCompanyPositionsRequestFilters {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyPositionsRequestFilters.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyPositionsRequestFilters.prototype, "query", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyPositionsRequestFilters.prototype, "unit_ids", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyPositionsRequestFilters.prototype, "include_unit_managers", void 0);
export class Pagination {
}
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], Pagination.prototype, "limit", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], Pagination.prototype, "offset", void 0);
export class GetCompanyPositionsRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], GetCompanyPositionsRequest.prototype, "pagination", void 0);
__decorate([
    ValidateNested(),
    Type(() => GetCompanyPositionsRequestFilters),
    IsOptional(),
    __metadata("design:type", GetCompanyPositionsRequestFilters)
], GetCompanyPositionsRequest.prototype, "filters", void 0);
export class TimezoneEmployeesFilters {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], TimezoneEmployeesFilters.prototype, "timezone_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], TimezoneEmployeesFilters.prototype, "unit_ids", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], TimezoneEmployeesFilters.prototype, "employee_ids", void 0);
export class TimezoneEmployeesRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], TimezoneEmployeesRequest.prototype, "pagination", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimezoneEmployeesFilters),
    IsOptional(),
    __metadata("design:type", TimezoneEmployeesFilters)
], TimezoneEmployeesRequest.prototype, "filters", void 0);
export class TimezoneExceptionsFilters {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], TimezoneExceptionsFilters.prototype, "timezone_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], TimezoneExceptionsFilters.prototype, "unit_ids", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], TimezoneExceptionsFilters.prototype, "employee_ids", void 0);
export class TimezoneExceptionsRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], TimezoneExceptionsRequest.prototype, "pagination", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimezoneExceptionsFilters),
    IsOptional(),
    __metadata("design:type", TimezoneExceptionsFilters)
], TimezoneExceptionsRequest.prototype, "filters", void 0);
export class EmployeeTimezone {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeTimezone.prototype, "employee_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EmployeeTimezone.prototype, "timezone_id", void 0);
export class UpdateEmployeesTimezoneRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeTimezone),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UpdateEmployeesTimezoneRequest.prototype, "employees", void 0);
export class UpdateCompanyCeoRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyCeoRequest.prototype, "first_name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyCeoRequest.prototype, "last_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyCeoRequest.prototype, "middle_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyCeoRequest.prototype, "position", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], UpdateCompanyCeoRequest.prototype, "first_name_cases", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], UpdateCompanyCeoRequest.prototype, "last_name_cases", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], UpdateCompanyCeoRequest.prototype, "middle_name_cases", void 0);
__decorate([
    ValidateNested(),
    Type(() => Cases),
    IsOptional(),
    __metadata("design:type", Cases)
], UpdateCompanyCeoRequest.prototype, "position_cases", void 0);
export class SmevValidationEsiaRequest {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], SmevValidationEsiaRequest.prototype, "ignore_smev_errors_esia", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], SmevValidationEsiaRequest.prototype, "apply_to_account", void 0);
export class SmevValidationErrorsRequestData {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SmevValidationErrorsRequestData.prototype, "error_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], SmevValidationErrorsRequestData.prototype, "ignore", void 0);
export class SmevValidationErrorsRequest {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], SmevValidationErrorsRequest.prototype, "apply_to_account", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => SmevValidationErrorsRequestData),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], SmevValidationErrorsRequest.prototype, "data", void 0);
export class UpdateEventTypeRequest {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateEventTypeRequest.prototype, "disabled", void 0);
export class UpdateCollectionsRequest {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UpdateCollectionsRequest.prototype, "collection_ids", void 0);
export class UpdateCompanyProfilesSettings {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], UpdateCompanyProfilesSettings.prototype, "enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanyProfilesSettings.prototype, "reset_default_profile", void 0);
__decorate([
    IsIn(['import', 'units']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyProfilesSettings.prototype, "source", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanyProfilesSettings.prototype, "unit_type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanyProfilesSettings.prototype, "include_separate_units", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateCompanyProfilesSettings.prototype, "units", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanyProfilesSettings.prototype, "vacation_schedule_profiles", void 0);
export class DeleteUserGroupRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteUserGroupRequest.prototype, "user_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteUserGroupRequest.prototype, "group_id", void 0);
export class AddUserGroupRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddUserGroupRequest.prototype, "user_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddUserGroupRequest.prototype, "group_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], AddUserGroupRequest.prototype, "profiles", void 0);
export class GetCompanyGroupListRequest {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetCompanyGroupListRequest.prototype, "company_ids", void 0);
export class UpdateNodeRoles {
}
__decorate([
    IsIn([
        'upload',
        'accept',
        'decline',
        'decline_sign',
        'sign',
        'system',
        'generate_document_from_template',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateNodeRoles.prototype, "action_type", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UpdateNodeRoles.prototype, "groups", void 0);
export class UpdateNode {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateNode.prototype, "node_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UpdateNodeRoles),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateNode.prototype, "roles", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateNode.prototype, "manager_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => DeadlineSettings),
    IsOptional(),
    __metadata("design:type", DeadlineSettings)
], UpdateNode.prototype, "deadline_settings", void 0);
export class UpdateNodesRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UpdateNode),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UpdateNodesRequest.prototype, "nodes", void 0);
export class DeleteWorkflowParticipantRequest {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], DeleteWorkflowParticipantRequest.prototype, "participant_ids", void 0);
export class AddWorkflowParticipantRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddWorkflowParticipantRequest.prototype, "group_id", void 0);
export class DeleteValidatorRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteValidatorRequest.prototype, "validator_id", void 0);
export class UpdateValidatorRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateValidatorRequest.prototype, "validator_id", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], UpdateValidatorRequest.prototype, "settings", void 0);
export class DeleteManagerSubstituteRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteManagerSubstituteRequest.prototype, "employee_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteManagerSubstituteRequest.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeleteManagerSubstituteRequest.prototype, "substitute_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DateRange),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], DeleteManagerSubstituteRequest.prototype, "dates", void 0);
__decorate([
    IsIn(['ALL', 'ALL_TEMPORARY', 'ALL_PERMANENT']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DeleteManagerSubstituteRequest.prototype, "scope", void 0);
export class CreateManagerSubstituteRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateManagerSubstituteRequest.prototype, "employee_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateManagerSubstituteRequest.prototype, "event_types", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateManagerSubstituteRequest.prototype, "substitute_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DateRange),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateManagerSubstituteRequest.prototype, "dates", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateManagerSubstituteRequest.prototype, "from_absences", void 0);
export class GetManagerSubstitutesListRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetManagerSubstitutesListRequest.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManagerSubstitutesListRequest.prototype, "search_employee", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManagerSubstitutesListRequest.prototype, "limit", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManagerSubstitutesListRequest.prototype, "offset", void 0);
export class CreateUnitManagerSetting {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateUnitManagerSetting.prototype, "event_type_id", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateUnitManagerSetting.prototype, "approve", void 0);
export class UpdateUnitRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateUnitRequest.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateUnitRequest.prototype, "parent_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateUnitRequest.prototype, "manager_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateUnitManagerSetting),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateUnitRequest.prototype, "manager_settings", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateUnitRequest.prototype, "assistants", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUnitRequest.prototype, "is_separate", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateUnitRequest.prototype, "manager_setting_approve", void 0);
export class CreateUnitRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateUnitRequest.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateUnitRequest.prototype, "parent_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateUnitRequest.prototype, "manager_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateUnitManagerSetting),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateUnitRequest.prototype, "manager_settings", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateUnitRequest.prototype, "assistants", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateUnitRequest.prototype, "is_separate", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateUnitRequest.prototype, "manager_setting_approve", void 0);
export class GetCompanyEmployeesRequestFilters {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyEmployeesRequestFilters.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "query", void 0);
__decorate([
    IsIn([
        'data_received',
        'documents_verification',
        'unep_application_signing',
        'unep_releasing',
        'unep_release_failed',
        'unep_release_paused',
        'invite_sent',
        'invite_expired',
        'active',
        'dismissed',
        'wait_registration',
    ]),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "fio", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "personnel_number", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "position", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyEmployeesRequestFilters.prototype, "positions", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "unit_name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "unit_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyEmployeesRequestFilters.prototype, "unit_ids", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "unit_type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyEmployeesRequestFilters.prototype, "include_unit_managers", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyEmployeesRequestFilters.prototype, "include_subunits_employees", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyEmployeesRequestFilters.prototype, "include_companies_from_account", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCompanyEmployeesRequestFilters.prototype, "include_foreign_managers", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCompanyEmployeesRequestFilters.prototype, "exclude_ids", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "exclude_employees_by_schedule_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCompanyEmployeesRequestFilters.prototype, "first_employee_id", void 0);
export class GetCompanyEmployeesRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], GetCompanyEmployeesRequest.prototype, "pagination", void 0);
__decorate([
    ValidateNested(),
    Type(() => GetCompanyEmployeesRequestFilters),
    IsOptional(),
    __metadata("design:type", GetCompanyEmployeesRequestFilters)
], GetCompanyEmployeesRequest.prototype, "filters", void 0);
export class UploadLogoRequest {
}
__decorate([
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], UploadLogoRequest.prototype, "main", void 0);
__decorate([
    Type(() => String),
    IsOptional(),
    __metadata("design:type", File)
], UploadLogoRequest.prototype, "compact", void 0);
export class CreateCompanyGroupRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateCompanyGroupRequest.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateCompanyGroupRequest.prototype, "parent_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateCompanyGroupRequest.prototype, "all_companies", void 0);
export class CheckCompanyGroupCreationRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckCompanyGroupCreationRequest.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CheckCompanyGroupCreationRequest.prototype, "parent_id", void 0);
export class UpdateCompanyManagerBlocksRequest {
}
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyManagerBlocksRequest.prototype, "manager_type", void 0);
export class ToggleCompanySkipAccountSyncRequest {
}
__decorate([
    IsIn([
        'show_closest_task_widget',
        'payslips_enabled',
        'early_employee_event_access_enabled',
        'manager_starts_from_parent_unit',
        'update_managers_in_events',
        'separate_units_enabled',
        'employee_download_pdf_access',
        'import_operational_units',
        'import_legal_units',
        'business_trips_enabled',
        'search_users_enabled',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ToggleCompanySkipAccountSyncRequest.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ToggleCompanySkipAccountSyncRequest.prototype, "skip", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ToggleCompanySkipAccountSyncRequest.prototype, "settings_value", void 0);
export class UpdateCompanySettingsRequest {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "import_operational_units", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "import_legal_units", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "payslips_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "update_managers_in_events", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "manager_starts_from_parent_unit", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "role_model_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "early_employee_event_access_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "separate_units_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "employee_download_pdf_access", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "show_closest_task_widget", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "business_trips_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "search_users_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "show_operational_manager", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "show_legal_manager", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "show_functional_manager", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanySettingsRequest.prototype, "timezone", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateCompanySettingsRequest.prototype, "import_timezones", void 0);
__decorate([
    IsIn(['always', 'direct_only', 'never']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateCompanySettingsRequest.prototype, "manager_setting_approve", void 0);
export class UpdateCompanyRoleModelItem {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], UpdateCompanyRoleModelItem.prototype, "object_id", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], UpdateCompanyRoleModelItem.prototype, "employees", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], UpdateCompanyRoleModelItem.prototype, "managers", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateCompanyRoleModelItem.prototype, "company_groups", void 0);
export class UpdateCompanyRoleModelRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UpdateCompanyRoleModelItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UpdateCompanyRoleModelRequest.prototype, "values", void 0);
export class UpdateCompanyEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyEmployee.prototype, "id", void 0);
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyEmployee.prototype, "sign_type", void 0);
export class UpdateCompanyRequest {
}
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyRequest.prototype, "sign_type", void 0);
__decorate([
    IsIn(['web', 'onecvk', 'public']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateCompanyRequest.prototype, "employee_sign_type_source", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UpdateCompanyEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UpdateCompanyRequest.prototype, "employees", void 0);
let SettingsService = class SettingsService {
    constructor(validator, http, unmarshaller, query) {
        this.validator = validator;
        this.http = http;
        this.unmarshaller = unmarshaller;
        this.query = query;
    }
    getCompanyPositions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyPositionsParams),
                this.validator.validateOrReject(body, GetCompanyPositionsRequest),
            ]);
            let requestPath = '/company/{company_id}/positions';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getTimezoneEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetTimezoneEmployeesParams),
                this.validator.validateOrReject(body, TimezoneEmployeesRequest),
            ]);
            let requestPath = '/company/{company_id}/timezone/employees';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, TimezoneEmployeesResponse);
            return response;
        });
    }
    getCompanyTimezones(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyTimezonesParams),
            ]);
            let requestPath = '/company/{company_id}/timezones';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, CompanyTimezonesResponse);
            return response;
        });
    }
    getTimezoneExceptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetTimezoneExceptionsParams),
                this.validator.validateOrReject(body, TimezoneExceptionsRequest),
            ]);
            let requestPath = '/company/{company_id}/timezone/exceptions';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, TimezoneExceptionsResponse);
            return response;
        });
    }
    getTimezoneFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetTimezoneFilterOptionsQuery),
            ]);
            let requestPath = '/timezone/options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getAvailableCompanyTimezoneFilters(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetAvailableCompanyTimezoneFiltersParams),
            ]);
            let requestPath = '/company/{company_id}/timezone/exceptions/available_filters';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, FiltersResponse);
            return response;
        });
    }
    updateEmployeesTimezone(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, UpdateEmployeesTimezoneRequest),
            ]);
            let requestPath = '/employee/timezone';
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getAccessLevels() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestPath = '/access-levels';
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetAccessLevelsResponse);
            return response;
        });
    }
    updateCompanyCeo(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanyCeoParams),
                this.validator.validateOrReject(body, UpdateCompanyCeoRequest),
            ]);
            let requestPath = '/company/{company_id}/ceo';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompanyCeo(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyCeoParams),
            ]);
            let requestPath = '/company/{company_id}/ceo';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyCeoResponse);
            return response;
        });
    }
    setCompanySmevValidationEsia(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, SetCompanySmevValidationEsiaParams),
                this.validator.validateOrReject(body, SmevValidationEsiaRequest),
            ]);
            let requestPath = '/company/{company_id}/smev_validation_esia';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompanySmevValidationEsia(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanySmevValidationEsiaParams),
            ]);
            let requestPath = '/company/{company_id}/smev_validation_esia';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, SmevValidationEsiaResponse);
            return response;
        });
    }
    setCompanySmevValidationErrors(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, SetCompanySmevValidationErrorsParams),
                this.validator.validateOrReject(body, SmevValidationErrorsRequest),
            ]);
            let requestPath = '/company/{company_id}/smev_validation';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompanySmevValidationErrors(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanySmevValidationErrorsParams),
            ]);
            let requestPath = '/company/{company_id}/smev_validation';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, SmevValidationErrorsResponse);
            return response;
        });
    }
    updateEventType(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateEventTypeParams),
                this.validator.validateOrReject(body, UpdateEventTypeRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    companyEventTypesCollection(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, CompanyEventTypesCollectionParams),
                this.validator.validateOrReject(body, UpdateCollectionsRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/collection';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    companyEventTypesCollectionOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, CompanyEventTypesCollectionOptionsParams),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/collection/options';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetCollectionOptionsResponse);
            return response;
        });
    }
    updateCompanyProfilesSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanyProfilesSettingsParams),
                this.validator.validateOrReject(body, UpdateCompanyProfilesSettings),
            ]);
            let requestPath = '/company/{company_id}/profiles/settings';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompanyProfilesSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyProfilesSettingsParams),
            ]);
            let requestPath = '/company/{company_id}/profiles/settings';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CompanyProfilesSettings);
            return response;
        });
    }
    getProfilesOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetProfilesOptionsQuery),
            ]);
            let requestPath = '/company/profiles/options';
            const result = yield this.http.get(requestPath, query, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getProfiles() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetProfilesQuery),
            ]);
            let requestPath = '/company/profiles';
            const result = yield this.http.get(requestPath, query, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetProfilesResponse);
            return response;
        });
    }
    deleteUserGroup(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, DeleteUserGroupRequest),
            ]);
            let requestPath = '/user/group';
            const result = yield this.http.delete(requestPath, body, {
                withSide: true,
            });
            return result;
        });
    }
    addUserGroup(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, AddUserGroupRequest),
            ]);
            let requestPath = '/user/group';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompanyGroupList(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, GetCompanyGroupListRequest),
            ]);
            let requestPath = '/company/group_list';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyGroupListResponse);
            return response;
        });
    }
    getNodeOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetNodeOptionsParams),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/node/options';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetNodeOptionsResponse);
            return response;
        });
    }
    updateNodes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateNodesParams),
                this.validator.validateOrReject(body, UpdateNodesRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/node';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getNewWorkflowParticipantOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetNewWorkflowParticipantOptionsParams),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/participant/options';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetNewWorkflowParticipantOptionsResponse);
            return response;
        });
    }
    deleteWorkflowParticipant(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DeleteWorkflowParticipantParams),
                this.validator.validateOrReject(body, DeleteWorkflowParticipantRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/participant';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.delete(requestPath, body, {
                withSide: true,
            });
            return result;
        });
    }
    addWorkflowParticipant(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, AddWorkflowParticipantParams),
                this.validator.validateOrReject(body, AddWorkflowParticipantRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/participant';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    deleteValidator(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DeleteValidatorParams),
                this.validator.validateOrReject(body, DeleteValidatorRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/validator';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.delete(requestPath, body, {
                withSide: true,
            });
            return result;
        });
    }
    updateValidator(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateValidatorParams),
                this.validator.validateOrReject(body, UpdateValidatorRequest),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/validator';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getEventTypeWorkflow(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventTypeWorkflowParams),
            ]);
            let requestPath = '/company/event_types/{event_type_id}/workflow';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetEventTypeWorkflowResponse);
            return response;
        });
    }
    getManagerSubstituteAbsenceOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetManagerSubstituteAbsenceOptionsQuery),
            ]);
            let requestPath = '/company/manager_substitute/absence_options';
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, ManagerSubstituteAbsenceOptionsResponse);
            return response;
        });
    }
    deleteManagerSubstitute(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, DeleteManagerSubstituteRequest),
            ]);
            let requestPath = '/company/manager_substitute';
            const result = yield this.http.delete(requestPath, body, {
                withSide: true,
            });
            return result;
        });
    }
    createManagerSubstitute(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, CreateManagerSubstituteRequest),
            ]);
            let requestPath = '/company/manager_substitute';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    getManagerSubstitutes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetManagerSubstitutesQuery),
            ]);
            let requestPath = '/company/manager_substitute';
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, GetManagerSubstitutesResponse);
            return response;
        });
    }
    getManagerSubstitutesList(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, GetManagerSubstitutesListRequest),
            ]);
            let requestPath = '/company/manager_substitute/list';
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetManagerSubstitutesListResponse);
            return response;
        });
    }
    getUnitStaff(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetUnitStaffQuery),
                this.validator.validateOrReject(params, GetUnitStaffParams),
            ]);
            let requestPath = '/company/{company_id}/unit/{unit_id}/staff';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, GetUnitStaffResponse);
            return response;
        });
    }
    deleteUnit(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DeleteUnitParams),
            ]);
            let requestPath = '/company/{company_id}/unit/{unit_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.delete(requestPath, {}, {});
            return result;
        });
    }
    updateUnit(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateUnitParams),
                this.validator.validateOrReject(body, UpdateUnitRequest),
            ]);
            let requestPath = '/company/{company_id}/unit/{unit_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, {});
            return result;
        });
    }
    getUnit(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([this.validator.validateOrReject(params, GetUnitParams)]);
            let requestPath = '/company/{company_id}/unit/{unit_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetUnitResponse);
            return response;
        });
    }
    createUnit(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, CreateUnitParams),
                this.validator.validateOrReject(body, CreateUnitRequest),
            ]);
            let requestPath = '/company/{company_id}/unit';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateUnitResponse);
            return response;
        });
    }
    getUnitChildren(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetUnitChildrenParams),
            ]);
            let requestPath = '/company/{company_id}/unit/{unit_id}/children';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetUnitChildrenResponse);
            return response;
        });
    }
    getUnitChildrenForBatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetUnitChildrenForBatchParams),
            ]);
            let requestPath = '/company/{company_id}/batch/unit/{unit_id}/children';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetUnitChildrenResponse);
            return response;
        });
    }
    getUnitsTree(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetUnitsTreeQuery),
                this.validator.validateOrReject(params, GetUnitsTreeParams),
            ]);
            let requestPath = '/company/{company_id}/unit/tree';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetUnitsTreeResponse);
            return response;
        });
    }
    getUnitsTreeForBatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetUnitsTreeForBatchQuery),
                this.validator.validateOrReject(params, GetUnitsTreeForBatchParams),
            ]);
            let requestPath = '/company/{company_id}/batch/unit/tree';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetUnitsTreeResponse);
            return response;
        });
    }
    getCompaniesFilterOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestPath = '/companies/options';
            const result = yield this.http.get(requestPath, {}, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getSegmentsFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetSegmentsFilterOptionsQuery),
            ]);
            let requestPath = '/segments/options';
            const result = yield this.http.get(requestPath, query, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getAbsenceTypesOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetAbsenceTypesOptionsQuery),
            ]);
            let requestPath = '/absences/options';
            const result = yield this.http.get(requestPath, query, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => AbsenceFilterOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getUnitsOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetUnitsOptionsQuery),
            ]);
            let requestPath = '/units/options';
            const result = yield this.http.get(requestPath, query, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getUnitTypes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetUnitTypesParams),
            ]);
            let requestPath = '/company/{company_id}/unit/types';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetUnitTypesResponse);
            return response;
        });
    }
    getCompanySubstituteEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCompanySubstituteEmployeesQuery),
                this.validator.validateOrReject(params, GetCompanySubstituteEmployeesParams),
            ]);
            let requestPath = '/company/{company_id}/substitute_employees/{employee_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyEmployeesResponse);
            return response;
        });
    }
    getCompanyEmployeesWithoutRoleModel(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCompanyEmployeesWithoutRoleModelQuery),
                this.validator.validateOrReject(params, GetCompanyEmployeesWithoutRoleModelParams),
            ]);
            let requestPath = '/company/{company_id}/employees/substitute_options';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyEmployeesSubstituteOptionsResponse);
            return response;
        });
    }
    getCompanyEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyEmployeesParams),
                this.validator.validateOrReject(body, GetCompanyEmployeesRequest),
            ]);
            let requestPath = '/company/{company_id}/employees';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyEmployeesResponse);
            return response;
        });
    }
    getCompanyEventTypes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCompanyEventTypesQuery),
                this.validator.validateOrReject(params, GetCompanyEventTypesParams),
            ]);
            let requestPath = '/company/{company_id}/event_types';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyEventTypesResponse);
            return response;
        });
    }
    getCompanyGroupUsers(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyGroupUsersParams),
            ]);
            let requestPath = '/company/{company_id}/group_users';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CompanyGroupUsers);
            return response;
        });
    }
    getCompanyLogo() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCompanyLogoQuery),
            ]);
            let requestPath = '/company/logo';
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            }, query);
            return result;
        });
    }
    getCompanyLogoById(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCompanyLogoByIdQuery),
                this.validator.validateOrReject(params, GetCompanyLogoByIdParams),
            ]);
            let requestPath = '/company/{company_id}/logo';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            }, query);
            return result;
        });
    }
    updateCompanyLogo(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanyLogoParams),
                this.validator.validateOrReject(body, UploadLogoRequest),
            ]);
            let requestPath = '/company/{company_id}/logo/upload';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { isJson: false });
            return result;
        });
    }
    getCompanyEventsStat(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyEventsStatParams),
            ]);
            let requestPath = '/company/{company_id}/events_stat';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, CompanyEventsStat);
            return response;
        });
    }
    createCompanyGroup(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, CreateCompanyGroupParams),
                this.validator.validateOrReject(body, CreateCompanyGroupRequest),
            ]);
            let requestPath = '/company/{company_id}/groups';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateCompanyGroupResponse);
            return response;
        });
    }
    getCompanyGroups(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCompanyGroupsQuery),
                this.validator.validateOrReject(params, GetCompanyGroupsParams),
            ]);
            let requestPath = '/company/{company_id}/groups';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, Groups);
            return response;
        });
    }
    checkCompanyGroupCreation(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, CheckCompanyGroupCreationParams),
                this.validator.validateOrReject(body, CheckCompanyGroupCreationRequest),
            ]);
            let requestPath = '/company/{company_id}/groups/check';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CheckCompanyGroupCreationResponse);
            return response;
        });
    }
    updateCompanyManagerBlocks(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanyManagerBlocksParams),
                this.validator.validateOrReject(body, UpdateCompanyManagerBlocksRequest),
            ]);
            let requestPath = '/company/{company_id}/manager_block';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, UpdateCompanyManagerBlocksResponse);
            return response;
        });
    }
    toggleCompanySkipAccountSync(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, ToggleCompanySkipAccountSyncParams),
                this.validator.validateOrReject(body, ToggleCompanySkipAccountSyncRequest),
            ]);
            let requestPath = '/company/{company_id}/settings/skip_account_sync';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EditableCompany);
            return response;
        });
    }
    updateCompanySettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanySettingsParams),
                this.validator.validateOrReject(body, UpdateCompanySettingsRequest),
            ]);
            let requestPath = '/company/{company_id}/settings';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompaniesForOrgStructure() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestPath = '/company/org_structure/list';
            const result = yield this.http.get(requestPath, {}, { reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, OrgStructureCompanyListResponse);
            return response;
        });
    }
    getCompaniesFromAccount(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompaniesFromAccountParams),
            ]);
            let requestPath = '/company/{company_id}/by_account';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, CompanyListResponse);
            return response;
        });
    }
    updateCompanyRoleModel(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanyRoleModelParams),
                this.validator.validateOrReject(body, UpdateCompanyRoleModelRequest),
            ]);
            let requestPath = '/company/{company_id}/role_model';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, { withSide: true });
            return result;
        });
    }
    getCompanyRoleModel(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyRoleModelParams),
            ]);
            let requestPath = '/company/{company_id}/role_model';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyRoleModelResponse);
            return response;
        });
    }
    updateCompany(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, UpdateCompanyParams),
                this.validator.validateOrReject(body, UpdateCompanyRequest),
            ]);
            let requestPath = '/company/{company_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.put(requestPath, body, {});
            return result;
        });
    }
    getCompany(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetCompanyParams),
            ]);
            let requestPath = '/company/{company_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetCompanyResponse);
            return response;
        });
    }
    getCompaniesFindByGroupAdmin() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestPath = '/company/list/find_by_group_admin';
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, CompanyListResponse);
            return response;
        });
    }
};
SettingsService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [ValidationService,
        HttpService,
        UnmarshallerService,
        QueryService])
], SettingsService);
export { SettingsService };
